import { render, staticRenderFns } from "./ConversionRates.vue?vue&type=template&id=0be88e27&scoped=true"
import script from "./ConversionRates.vue?vue&type=script&lang=js"
export * from "./ConversionRates.vue?vue&type=script&lang=js"
import style0 from "./ConversionRates.vue?vue&type=style&index=0&id=0be88e27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be88e27",
  null
  
)

export default component.exports